import { AsyncErrorBoundary } from '@/context/async-error-boundary';
import AppLayout from '@/layout/AppLayout';
import BaseLayout from '@/layout/BaseLayout';
import Account from '@/pages/account';
import ConfirmAccount from '@/pages/auth/confirm-account';
import ForgotPassword from '@/pages/auth/forgot-password';
import Login from '@/pages/auth/login';
import ResetPassword from '@/pages/auth/reset-password';
import SignUp from '@/pages/auth/signup';
import VerifyEmailChange from '@/pages/auth/verify-email-change';
import VerifyMfa from '@/pages/auth/verify-mfa';
import MFAHome from '@/pages/home';
import HomePage from '@/pages/home/home';
import NotFound from '@/pages/NotFound';
import Session from '@/pages/sessions';
import Settings from '@/pages/settings';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from 'react-router-dom';
import AuthRoute from './auth.route';
import PublicRoute from './public.route';
import MagicLink from '@/pages/auth/magic-link';

export const appRouter = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route
                element={
                    <AsyncErrorBoundary showCancelButton={false}>
                        <AuthRoute />
                    </AsyncErrorBoundary>
                }>
                <Route element={<AppLayout />}>
                    <Route
                        path='mfa'
                        element={<MFAHome />}
                    />
                    <Route
                        path='sessions'
                        element={<Session />}
                    />
                    <Route
                        path='account'
                        element={<Account />}
                    />
                    <Route
                        path='settings'
                        element={<Settings />}
                    />
                </Route>
            </Route>

            <Route
                element={
                    <AsyncErrorBoundary showCancelButton={true}>
                        <PublicRoute />
                    </AsyncErrorBoundary>
                }>
                <Route
                    path='/'
                    element={<HomePage />}
                />
                <Route
                    path='verify-email'
                    element={<ConfirmAccount />}
                />
                <Route
                    path='verify-email-change'
                    element={<VerifyEmailChange />}
                />
                <Route
                    path='magic-link'
                    element={<MagicLink />}
                />
                <Route element={<BaseLayout />}>
                    <Route
                        path='/login'
                        element={<Login />}
                    />
                    <Route
                        path='signup'
                        element={<SignUp />}
                    />
                    <Route
                        path='forgot-password'
                        element={<ForgotPassword />}
                    />
                    <Route
                        path='reset-password'
                        element={<ResetPassword />}
                    />
                    <Route
                        path='verify-mfa'
                        element={<VerifyMfa />}
                    />
                </Route>
            </Route>

            <Route
                path='*'
                element={
                    <AsyncErrorBoundary showCancelButton={false}>
                        <NotFound />
                    </AsyncErrorBoundary>
                }
            />
        </Route>,
    ),
    {
        future: { v7_relativeSplatPath: true, v7_startTransition: true },
    },
);
